import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';
import { BaseValidator } from '@tcm-modules/tcm-core.module';

@Directive({
    selector: '[greaterThanZero]',
    providers: [
        { provide: NG_VALIDATORS, useExisting: GreaterThanZeroValidator, multi: true }
    ],
    standalone: false
})
export class GreaterThanZeroValidator extends BaseValidator implements OnChanges {

  @Input()
  greaterThanZero: number;

  constructor() {
    super('greaterThanZero');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.greaterThanZero && changes.greaterThanZero.isFirstChange()) {
      return;
    }

    this._onChange();
  }

  protected getValidationResult(control: any) {
    if (control.value == null || control.value > 0) {
      return null;
    }

    return this.buildValidationErrorResult({});
  }
}
